// WebtoonVerse — all static demo content lives here.
// Worlds, characters, hardcoded dialogue trees, story moments, and About copy.

export const IMAGES = {
  portal_cafe:
    "https://static.prod-images.emergentagent.com/jobs/458e2ac0-adcd-4873-848a-9398b5adf1f2/images/054576658a57fd86de69130d6a8cb23c83811b17501b3ac84d7b1789d9188460.png",
  portal_academy:
    "https://static.prod-images.emergentagent.com/jobs/458e2ac0-adcd-4873-848a-9398b5adf1f2/images/e697080c942e86e9f86661306b1e7d479c70b91a6283ee94b3a73b49b81e02cb.png",
  portal_alley:
    "https://static.prod-images.emergentagent.com/jobs/458e2ac0-adcd-4873-848a-9398b5adf1f2/images/e1ad26c182b96de46d181e7d65afff88f0de14a21fae05ef4dd8abc3cdacda96.png",
  avatar_cafe:
    "https://static.prod-images.emergentagent.com/jobs/458e2ac0-adcd-4873-848a-9398b5adf1f2/images/f4cbde70cad18da086f30c1766e3030448cbfe47fa341adce031f1745db782e4.png",
  avatar_academy:
    "https://static.prod-images.emergentagent.com/jobs/458e2ac0-adcd-4873-848a-9398b5adf1f2/images/41d6d2aed294593e9cabc363860d66f2eb19674a06d446ab33df00e9f99ccd16.png",
  avatar_noir:
    "https://static.prod-images.emergentagent.com/jobs/458e2ac0-adcd-4873-848a-9398b5adf1f2/images/ee5e5c6715b79374b3961d6a4693ebeef641dee7ba7f26322a6c3e2e3c6b1aa9.png",
};

export const WORLDS = [
  {
    id: "cafe",
    name: "Café Romance",
    koreanName: "카페 로맨스",
    tagline: "A slice-of-life romance brewed in the rain.",
    genre: "Slice-of-life · Romance",
    cover: IMAGES.portal_cafe,
    accent: "#FF2A6D",
    accentSoft: "rgba(255, 42, 109, 0.45)",
    glow: "rgba(255, 42, 109, 0.55)",
    gradient:
      "radial-gradient(circle at 25% 25%, rgba(255,42,109,0.30), transparent 45%), radial-gradient(circle at 80% 70%, rgba(255,148,180,0.18), transparent 50%), #0a0406",
    particle: "bokeh",
    particleColor: "#FF7DA3",
    scene:
      "You step into Hyemi's café on a rainy Seoul evening. The windows are fogged, vinyl crackles somewhere in the corner, and the smell of fresh espresso curls through the warm light. Someone has been waiting for you.",
    characters: [
      {
        id: "hyemi",
        name: "Hyemi",
        koreanName: "혜미",
        role: "Café owner · secretly a webtoon artist",
        bio: "Warm, shy, and always sketching when she thinks no one is watching.",
        avatar: IMAGES.avatar_cafe,
        accent: "#FF2A6D",
        greeting:
          "Oh—! Welcome in. *wipes her hands on her apron* You're soaked from the rain… here, sit by the window. Can I get you something warm?",
        fallback:
          "*tilts her head with a shy smile* Tell me more about that… I like the way you see things.",
        suggestions: [
          "What do you recommend?",
          "Are you a webtoon artist?",
          "Why do you love the rain?",
        ],
        responses: [
          {
            keywords: ["coffee", "drink", "order", "latte", "tea", "menu", "recommend"],
            text: "*a soft smile* The vanilla latte is my favorite… I draw little hearts in the foam when no one's looking. Don't tell anyone, okay?",
          },
          {
            keywords: ["webtoon", "draw", "artist", "art", "comic", "manhwa", "sketch"],
            text: "*freezes, then looks down* You… you know about that? *a quiet laugh* Yes. I draw a webtoon at night. This café is kind of the setting. The characters… are based on people who come here.",
          },
          {
            keywords: ["rain", "weather", "evening", "night", "outside"],
            text: "I love rainy evenings like this. The café goes quiet, the lights turn warm… it's when I feel most like drawing. Rain makes people honest, don't you think?",
          },
          {
            keywords: ["love", "romance", "crush", "date", "feelings", "heart"],
            text: "*blushes, hides behind a coffee cup* W-why would you ask me that…? There might be… someone. A regular. But that's a story for another chapter.",
          },
          {
            keywords: ["name", "who", "yourself", "you"],
            text: "Me? I'm Hyemi. I've run this little café for three years now. It's small, but… it's mine. And it holds a lot of stories.",
          },
        ],
      },
      {
        id: "junho",
        name: "Junho",
        koreanName: "준호",
        role: "Regular customer · indie songwriter",
        bio: "Always by the window with a notebook and a half-finished melody.",
        avatar: "/characters/junho.png",
        accent: "#FF9CC0",
        greeting:
          "*looks up from a notebook, one earbud in* Oh, hey. Didn't see you there. I'm just… writing a song about this place. Pull up a chair.",
        fallback: "*hums a few notes* Hm. Tell me more — you might end up in a lyric.",
        suggestions: ["Do you play music?", "What do you think of Hyemi?", "Who are you?"],
        responses: [
          {
            keywords: ["music", "song", "play", "guitar", "sing", "lyric"],
            text: "*grins* Yeah, I play a little. Indie stuff, mostly. I come here 'cause the rain on that window is the best metronome in Seoul.",
          },
          {
            keywords: ["hyemi", "owner", "her", "she"],
            text: "*lowers his voice* Hyemi? She's… something else. Draws all night, thinks nobody notices. I noticed. *looks away* Anyway.",
          },
          {
            keywords: ["name", "who", "you", "yourself"],
            text: "Junho. Songwriter, professional café-sitter, occasional dreamer. Nice to meet you.",
          },
        ],
      },
    ],
    storyMoment: {
      prompt:
        "The café lights flicker, then dim to candle-glow. Outside, the rain stops all at once.",
      choices: [
        {
          id: "A",
          label: "Investigate the fuse box",
          result:
            "You slip behind the counter. The fuse box hangs open — and taped inside is a torn webtoon panel… of you, sitting exactly where you sat moments ago. Hyemi hasn't been drawing the past. She's been drawing the future.",
        },
        {
          id: "B",
          label: "Stay seated and enjoy the candlelight",
          result:
            "You let the warmth wrap around you. Hyemi sets down a candle and a fresh latte, a tiny heart drawn in the foam. 'The power does this sometimes,' she smiles. 'I think the café likes the quiet too.'",
        },
        {
          id: "C",
          label: "Ask Hyemi what's happening",
          result:
            "Hyemi pauses, pencil mid-air. '…You noticed?' she whispers. 'The lights flicker whenever I draw something that's about to come true.' Slowly, she turns her sketchbook toward you.",
        },
      ],
    },
  },
  {
    id: "academy",
    name: "Hanyang Academy",
    koreanName: "한양 아카데미",
    tagline: "A fantasy school where the staircases move and books read you back.",
    genre: "Fantasy · School",
    cover: IMAGES.portal_academy,
    accent: "#B14EDB",
    accentSoft: "rgba(177, 78, 219, 0.45)",
    glow: "rgba(177, 78, 219, 0.55)",
    gradient:
      "radial-gradient(circle at 20% 30%, rgba(177,78,219,0.30), transparent 45%), radial-gradient(circle at 80% 60%, rgba(5,217,232,0.20), transparent 50%), #04060f",
    particle: "stars",
    particleColor: "#9FE8FF",
    scene:
      "You arrive at Hanyang Academy as twilight bleeds violet across enchanted spires. Lanterns drift through the courtyard on their own, the air hums with ozone, and a staircase quietly rearranges itself behind you. Magic here is not learned — it is befriended.",
    characters: [
      {
        id: "jiwoo",
        name: "Jiwoo",
        koreanName: "지우",
        role: "Third-year mage · top of her class",
        bio: "Playful and mysterious, with a spark of cyan light always at her fingertips.",
        avatar: IMAGES.avatar_academy,
        accent: "#05D9E8",
        greeting:
          "*a spark of cyan light dances on her fingertip* Well, well. A new face at Hanyang Academy. *winks* Careful — the staircases here move when you're not looking.",
        fallback:
          "*tilts her head, mischievous* Curious, curious… tell me more, and I might let you in on a secret.",
        suggestions: [
          "Can you teach me a spell?",
          "What's special about this academy?",
          "Tell me a secret.",
        ],
        responses: [
          {
            keywords: ["magic", "spell", "cast", "power", "rune", "teach", "learn"],
            text: "*twirls a glowing rune* Magic? Oh, it's just rearranged curiosity. Want me to teach you a spark? Mind the eyebrows.",
          },
          {
            keywords: ["school", "academy", "class", "study", "hanyang", "special"],
            text: "Hanyang Academy — oldest magic school in the realm. The library has books that read you back. I'd avoid the third floor after dark, if I were you.",
          },
          {
            keywords: ["secret", "mystery", "hidden", "danger", "midnight", "door"],
            text: "*eyes glint* Secrets? This whole school is one. There's a door that only appears at midnight… but I've said too much already. *finger to her lips*",
          },
          {
            keywords: ["lost", "where", "help", "find"],
            text: "Lost already? *laughs* Follow the floating lanterns — they like newcomers. Usually they lead somewhere useful. Usually.",
          },
          {
            keywords: ["name", "who", "you", "yourself"],
            text: "*a mock bow* Jiwoo, third-year, top of my class — well, tied. With a rival I refuse to name. *grins*",
          },
        ],
      },
      {
        id: "seora",
        name: "Seora",
        koreanName: "서라",
        role: "Head Prefect · Disciplinary Committee",
        bio: "Formal and proud. Keeps the academy from descending into chaos.",
        avatar: "/characters/seora.png",
        accent: "#7C5CFF",
        greeting:
          "*straightens her badge* Halt. Visitor's permit? …None? *sighs* Fine. I'm the prefect here. Follow the rules and we'll have no problems.",
        fallback: "*narrows her eyes* Elaborate. I do not deal in vague statements.",
        suggestions: ["What are the rules here?", "What about Jiwoo?", "Who are you?"],
        responses: [
          {
            keywords: ["rule", "permit", "allowed", "can i", "curfew", "law"],
            text: "Rules exist for a reason. Curfew is at nine, no unsanctioned spellcasting in the corridors, and absolutely no feeding the library books.",
          },
          {
            keywords: ["jiwoo", "her", "rival", "mage"],
            text: "*frowns* Jiwoo. Talented, reckless, and perpetually late. If you must learn magic, at least learn discipline first.",
          },
          {
            keywords: ["name", "who", "you", "yourself"],
            text: "Prefect Seora. Head of the Disciplinary Committee. I keep this academy from descending into chaos. Someone has to.",
          },
        ],
      },
    ],
    storyMoment: {
      prompt:
        "A spellbook tears itself from the shelf, pages glowing cyan, hovering at eye level. The air smells of ozone.",
      choices: [
        {
          id: "A",
          label: "Grab the book",
          result:
            "Your fingers close on the spine. Ice-cold. The pages flip to a portrait — your name written in a script you've never learned. 'Ah,' says Jiwoo behind you, 'the library chose you. That's never happened to a visitor.'",
        },
        {
          id: "B",
          label: "Cast a counter-rune",
          result:
            "You trace the rune Jiwoo showed you. The book freezes mid-air, then bows — actually bows — and floats gently back to its shelf. Somewhere, Jiwoo applauds. 'Natural talent. Annoying, isn't it, Seora?'",
        },
        {
          id: "C",
          label: "Call for Jiwoo",
          result:
            "'Jiwoo!' The mage appears in a swirl of sparks, utterly delighted. 'The Whispering Codex! It only wakes for someone with a story worth finishing.' She grins. 'So — what's yours?'",
        },
      ],
    },
  },
  {
    id: "alley",
    name: "Neon Alley",
    koreanName: "네온 골목",
    tagline: "A noir thriller where the broken streetlight knows your name.",
    genre: "Thriller · Noir",
    cover: IMAGES.portal_alley,
    accent: "#FF1E56",
    accentSoft: "rgba(255, 30, 86, 0.45)",
    glow: "rgba(255, 30, 86, 0.55)",
    gradient:
      "radial-gradient(circle at 30% 20%, rgba(255,30,86,0.28), transparent 45%), radial-gradient(circle at 75% 75%, rgba(120,20,60,0.30), transparent 55%), #080203",
    particle: "embers",
    particleColor: "#FF6B6B",
    scene:
      "You turn into Neon Alley after midnight. Rain slicks the asphalt into a mirror of broken signs — a ramen stall, a shuttered club, a single streetlight flickering in B-flat. Somewhere ahead, a case has gone cold. Someone is still watching it.",
    characters: [
      {
        id: "min",
        name: "Detective Min",
        koreanName: "민 형사",
        role: "Detective · working a cold case",
        bio: "Terse and sharp. Trusts evidence, cigarettes, and very little else.",
        avatar: IMAGES.avatar_noir,
        accent: "#FF1E56",
        greeting:
          "*doesn't look up from the case file* You lost? Neon Alley's no place to wander. State your business. Quick.",
        fallback: "*stares flatly* Get to the point.",
        suggestions: ["What case are you on?", "Is it dangerous here?", "Who is Luna?"],
        responses: [
          {
            keywords: ["case", "crime", "murder", "investigate", "clue", "missing"],
            text: "Three disappearances. Same alley. Same flickering light. No bodies. *taps the file* Coincidence is a word for people who don't look closely.",
          },
          {
            keywords: ["danger", "scared", "safe", "help", "afraid"],
            text: "Stay behind me, keep your mouth shut, and don't touch anything. This city eats the curious.",
          },
          {
            keywords: ["luna", "singer", "club", "informant"],
            text: "*pauses* Luna. She knows more than she sings. If you're talking to her, watch your wallet — and your story.",
          },
          {
            keywords: ["light", "flicker", "neon", "streetlight", "cold"],
            text: "That light's been broken for years. Funny thing — it only flickers when someone's about to vanish. *narrows his eyes* You feel cold yet?",
          },
          {
            keywords: ["name", "who", "you", "yourself"],
            text: "Min. Detective. That's all you need. *lights a cigarette* The less you know, the longer you last.",
          },
        ],
      },
      {
        id: "luna",
        name: "Luna",
        koreanName: "루나",
        role: "Lounge singer · the alley's informant",
        bio: "Sultry and cryptic. Trades in secrets and sad songs in B-flat.",
        avatar: "/characters/luna.png",
        accent: "#FF6B9D",
        greeting:
          "*exhales smoke beneath a red neon sign* New in the alley? *a slow smile* Everyone who comes here is looking for something. What's your poison, sugar?",
        fallback:
          "*swirls her drink* Mmm. Go on… the night is long, and I'm a very good listener.",
        suggestions: ["Tell me a secret.", "What about Detective Min?", "Who are you?"],
        responses: [
          {
            keywords: ["info", "know", "secret", "tell", "rumor"],
            text: "Information's the only currency that matters down here. I've got plenty. *leans in* But it'll cost you a story of your own.",
          },
          {
            keywords: ["min", "detective", "cop", "him"],
            text: "*laughs softly* Min? That brooding shadow thinks he's chasing a case. He's chasing a ghost. We all are.",
          },
          {
            keywords: ["sing", "song", "club", "music", "lounge"],
            text: "I sing what the alley whispers. Sad songs, mostly. The neon hums in B-flat, did you know? *winks*",
          },
          {
            keywords: ["name", "who", "you", "yourself"],
            text: "Luna. The alley's worst-kept secret and its best-kept one. *tilts her head* Both can be true at midnight.",
          },
        ],
      },
    ],
    storyMoment: {
      prompt:
        "A shadow darts past the broken streetlight. The neon flickers in B-flat. The temperature drops.",
      choices: [
        {
          id: "A",
          label: "Chase the shadow",
          result:
            "You bolt after it. The alley twists impossibly — and you're suddenly back where you started, breath fogging. On the wet ground: a single photograph of the alley, with a figure in it that looks exactly like you, mid-run.",
        },
        {
          id: "B",
          label: "Press against the wall",
          result:
            "You go still. The shadow passes inches away — cold as river water — and dissolves into the flickering light. Detective Min's voice, low at your ear: 'Smart. The ones who run are the ones who don't come back.'",
        },
        {
          id: "C",
          label: "Signal Detective Min",
          result:
            "Min is beside you before you finish the gesture. 'Fourth one tonight,' he mutters, watching the light die. 'Whatever's taking them… it's curious about you now.' He doesn't sound reassuring.",
        },
      ],
    },
  },
];

// Pick a response from a character's hardcoded dialogue tree based on keywords.
export function getCharacterResponse(character, userText) {
  const text = (userText || "").toLowerCase();
  for (const r of character.responses) {
    if (r.keywords.some((kw) => text.includes(kw))) {
      return r.text;
    }
  }
  return character.fallback;
}

export const ABOUT = {
  question: 'What is "future content"?',
  intro:
    "Content that doesn't just deliver a story — it hosts you inside it. WebtoonVerse reimagines Korean webtoons as AI-driven spatial experiences. Instead of scrolling panels, you walk into the world, meet the characters, and shape the moment. It combines AI conversational agents, metaverse spatial design, and Hallyu IP into a new content format.",
  points: [
    {
      title: "Spatial composition",
      body: "Each webtoon becomes a themed environment — a café, an academy, an alley.",
    },
    {
      title: "Activities",
      body: "Free chat with characters, triggered story moments, and open world exploration.",
    },
    {
      title: "Relationship to existing content",
      body: "Built on top of webtoon IP — the original webtoon becomes the 'source map' for the world.",
    },
    {
      title: "Why it's future content",
      body: "It dissolves the line between reader and character. Passive consumption becomes participatory storytelling.",
    },
    {
      title: "Value",
      body: "Deeper IP engagement, longer fan retention, new monetization (paid worlds, character DLC), and the expansion of Hallyu into spatial media.",
    },
  ],
};

// ============================================================
//  EXPANSION DATA — interactions, progression, gifts, mini-games
// ============================================================

export const PROVERBS = [
  "이야기는 끝나지 않는다 — Stories never end",
  "모든 문은 누군가를 기다린다 — Every door waits for someone",
  "웹툰은 살아 숨 쉰다 — A webtoon breathes",
  "독자가 들어서면 세계가 깨어난다 — When a reader steps in, the world awakens",
];

export const MOOD_WORDS = {
  compliments: [
    "love", "beautiful", "amazing", "nice", "great", "wonderful", "kind", "sweet",
    "cool", "awesome", "talented", "pretty", "good", "lovely", "brilliant", "gorgeous",
    "cute", "charming", "impressive", "wow", "best", "favorite", "admire", "respect", "thank",
  ],
  rude: [
    "stupid", "hate", "ugly", "boring", "dumb", "idiot", "shut up", "lame", "worst",
    "annoying", "gross", "creepy", "weird", "whatever", "useless", "shut",
  ],
  probe: [
    "secret", "hidden", "truth", "real name", "who are you really", "mystery",
    "confess", "hiding", "pen name", "suspect", "what happened", "what really",
  ],
};

export const WORLD_EXTRAS = {
  cafe: {
    ambient: "steam",
    sceneKr:
      "비 내리는 어느 서울의 저녁, 혜미의 카페로 들어섭니다. 창문은 김으로 흐려지고, 갓 내린 에스프레소 향이 따뜻한 불빛 사이로 번집니다.",
    minigame: {
      name: "Latte Art Challenge",
      nameKr: "라떼 아트 챌린지",
      reward:
        "Hyemi's eyes go wide at your latte art. '…You made this? For me?' For a moment, the rain, the café, and her smile are the whole story.",
    },
    gifts: [
      { id: "latte", name: "Vanilla Latte", nameKr: "바닐라 라떼", icon: "Coffee" },
      { id: "flower", name: "Single Rose", nameKr: "장미 한 송이", icon: "Flower2" },
      { id: "sketchbook", name: "Sketchbook", nameKr: "스케치북", icon: "Notebook" },
    ],
  },
  academy: {
    ambient: "sparkles",
    sceneKr:
      "황혼이 보랏빛으로 물든 한양 아카데미에 도착합니다. 등불은 스스로 떠다니고, 공기엔 마법의 기운이 감돕니다. 계단은 조용히 자리를 바꿉니다.",
    minigame: {
      name: "Spell Casting",
      nameKr: "주문 시전",
      reward:
        "The rune flares to life under your hand. Jiwoo grins, delighted: 'Natural talent. The academy chose well — for once.'",
    },
    gifts: [
      { id: "scroll", name: "Spell Scroll", nameKr: "주문 두루마리", icon: "ScrollText" },
      { id: "crystal", name: "Star Crystal", nameKr: "별 수정", icon: "Gem" },
      { id: "lantern", name: "Spirit Lantern", nameKr: "영혼 등불", icon: "Flame" },
    ],
  },
  alley: {
    ambient: "rain",
    sceneKr:
      "자정이 지난 네온 골목으로 들어섭니다. 빗물에 젖은 아스팔트가 부서진 간판을 비추고, 가로등 하나가 깜빡입니다. 식어버린 사건 하나가 당신을 기다립니다.",
    minigame: {
      name: "Clue Hunt",
      nameKr: "단서 찾기",
      reward:
        "Three clues, one truth. Detective Min nods once, slow: 'You see what others miss. Kang's club. Tonight.'",
    },
    gifts: [
      { id: "coffee", name: "Black Coffee", nameKr: "블랙 커피", icon: "Coffee" },
      { id: "casefile", name: "Case File", nameKr: "사건 파일", icon: "FolderOpen" },
      { id: "vinyl", name: "Vinyl Record", nameKr: "LP 레코드", icon: "Disc3" },
    ],
  },
};

export const CHARACTER_EXTRAS = {
  hyemi: {
    roleKr: "카페 주인 · 비밀 웹툰 작가",
    perfectGift: "sketchbook",
    secretProbe: -16,
    giftReaction:
      "*gasps, holding it to her chest* A sketchbook… for me? *a trembling smile* Then I'll draw something just for you. Maybe… you'll be the main character.",
    secret:
      "*leans in, voice barely a whisper* My webtoon is published under the pen name 'RainyPanel.' The café in it… is this one. And the regular I keep drawing… *she blushes* …looks a little like you.",
    secretKr: "제 웹툰은 '레이니패널'이라는 이름으로 연재돼요. 그 안의 카페는 바로 이곳이에요.",
    secretTease: "*hides behind her cup* Maybe… if I trusted you a little more.",
    quick: {
      compliment: "Your café feels like home.",
      topics: ["What do you recommend?", "Tell me about your art.", "Do you like the rain?"],
      secretAsk: "What's your webtoon pen name?",
    },
  },
  junho: {
    roleKr: "단골 손님 · 인디 작곡가",
    perfectGift: "latte",
    secretProbe: -8,
    giftReaction:
      "*sets down his pen* You read my mind. Black coffee, window seat, rain on the glass — that's the whole song, right there. Thanks.",
    secret:
      "*quietly, almost to himself* The song I'm writing? It's called 'Hyemi.' …Don't tell her. Please.",
    secretKr: "제가 쓰는 노래 제목은 '혜미'예요. …그녀에겐 비밀이에요.",
    secretTease: "*strums a nervous chord* Ha… not yet. Buy me another coffee first.",
    quick: {
      compliment: "Your music sounds amazing.",
      topics: ["Do you play music?", "What about Hyemi?", "What are you writing?"],
      secretAsk: "What's your song really about?",
    },
  },
  jiwoo: {
    roleKr: "3학년 마법사 · 수석",
    perfectGift: "crystal",
    secretProbe: -8,
    giftReaction:
      "*eyes sparkle* A star crystal?! Do you know how rare these are? *breathes a spark into it* There — now it holds a wish. Yours to keep.",
    secret:
      "*flicks her wrist; a tiny constellation blooms in the air* This is the Spark of Beginnings — the first spell I ever learned. I've never shown a visitor. Don't make me regret it.",
    secretKr: "이건 '시작의 불꽃' — 내가 처음 배운 주문이야. 방문객에게 보여준 건 네가 처음이야.",
    secretTease: "*wags a finger* Secrets are earned, not asked for. Win me over.",
    quick: {
      compliment: "You're an incredible mage.",
      topics: ["Teach me a spell.", "What's special here?", "Where do the lanterns lead?"],
      secretAsk: "Show me your first spell.",
    },
  },
  seora: {
    roleKr: "수석 학생감 · 규율 위원장",
    perfectGift: "lantern",
    secretProbe: -10,
    giftReaction:
      "*accepts it stiffly, then softens* A spirit lantern… for the bell tower, perhaps. *almost a smile* Thank you. I'll allow you one broken rule today.",
    secret:
      "*glances around, then quietly* …I break curfew too. Once a month I climb the bell tower to watch the stars. Discipline is exhausting. Don't you dare tell Jiwoo.",
    secretKr: "사실 나도 통금을 어겨. 한 달에 한 번 종탑에 올라 별을 봐. 지우에겐 절대 말하지 마.",
    secretTease: "Absolutely not. I barely know you. *crosses her arms*",
    quick: {
      compliment: "You keep this place safe — respect.",
      topics: ["What are the rules?", "What about Jiwoo?", "Who are you?"],
      secretAsk: "Do you ever break a rule?",
    },
  },
  min: {
    roleKr: "형사 · 미제 사건 담당",
    perfectGift: "casefile",
    secretProbe: 12,
    giftReaction:
      "*actually looks up* …Where did you get this? *flips it open* This is the page that went missing. You might've just cracked it. Don't make me thank you twice.",
    secret:
      "*low, certain* The suspect's name is Kang. Runs the shuttered club at the alley's end. I can't prove it yet — but you didn't hear it from me.",
    secretKr: "용의자의 이름은 강. 골목 끝 폐업한 클럽을 운영하지. 아직 증거는 없어.",
    secretTease: "*flat stare* You haven't earned that. Keep talking.",
    quick: {
      compliment: "You're a sharp detective.",
      topics: ["What's the case?", "Is it dangerous?", "Who is Luna?"],
      secretAsk: "Who's your suspect?",
    },
  },
  luna: {
    roleKr: "라운지 가수 · 골목의 정보원",
    perfectGift: "vinyl",
    secretProbe: -6,
    giftReaction:
      "*a genuine smile, rare* You remembered I sing. *holds the record close* For this… I'll tell you something true. Just once.",
    secret:
      "*sets down her drink* The disappearances? No one's vanishing. They choose to stay — inside the song. I'm the only one who ever came back. *winks* So far.",
    secretKr: "실종이 아니야. 그들은 노래 속에 남기로 선택한 거야. 돌아온 건 나뿐이지. 지금까진.",
    secretTease: "*smiles slyly* Mmm. The night's still young. Warm me up first, sugar.",
    quick: {
      compliment: "Your voice must be beautiful.",
      topics: ["Tell me a secret.", "What about Min?", "Do you sing here?"],
      secretAsk: "What really happened to them?",
    },
  },
};

export const ACHIEVEMENTS = [
  { id: "first_chat", title: "First Conversation", titleKr: "첫 대화", icon: "MessageCircle", desc: "Talk to your first character." },
  { id: "first_secret", title: "Secret Keeper", titleKr: "비밀 지킴이", icon: "KeyRound", desc: "Unlock a character's secret." },
  { id: "all_worlds", title: "World Traveler", titleKr: "세계 여행자", icon: "Globe", desc: "Visit all three worlds." },
  { id: "perfect_gift", title: "The Perfect Gift", titleKr: "완벽한 선물", icon: "Gift", desc: "Give a character their perfect gift." },
  { id: "all_story", title: "Storyteller", titleKr: "이야기꾼", icon: "Sparkles", desc: "Trigger a story moment in every world." },
  { id: "all_secrets", title: "Confidant", titleKr: "절친", icon: "Heart", desc: "Unlock every character's secret." },
  { id: "minigame_master", title: "Game On", titleKr: "게임 마스터", icon: "Gamepad2", desc: "Complete all three mini-games." },
  { id: "completionist", title: "Part of the Verse", titleKr: "WebtoonVerse의 일부", icon: "Crown", desc: "Reach 100% completion." },
];

export const AUTHOR_STUDIO = {
  id: "studio",
  name: "The Author's Studio",
  koreanName: "작가의 작업실",
  accent: "#FFD166",
  accentSoft: "rgba(255,209,102,0.45)",
  glow: "rgba(255,209,102,0.55)",
  gradient:
    "radial-gradient(circle at 30% 25%, rgba(255,209,102,0.20), transparent 45%), radial-gradient(circle at 75% 70%, rgba(177,78,219,0.16), transparent 50%), #0a0805",
  lines: [
    "You found it — the room where every world begins.",
    "When I started drawing WebtoonVerse, it was only panels on a screen. Lines, ink, and a lot of silence.",
    "But you didn't just read it. You stepped inside. You sat in Hyemi's café, cast a spell with Jiwoo, and stood beside Min in the rain.",
    "That's the secret of future content — the story was never finished. It was only ever waiting for you to finish it.",
    "Thank you for stepping inside.",
  ],
  signature: "— the author · 작가 드림",
  finalKr: "당신은 이제 WebtoonVerse의 일부입니다 — You are now part of WebtoonVerse.",
};

export const CHARACTER_IDS = ["hyemi", "junho", "jiwoo", "seora", "min", "luna"];
export const WORLD_IDS = ["cafe", "academy", "alley"];

export function worldOfCharacter(charId) {
  const w = WORLDS.find((wd) => wd.characters.some((c) => c.id === charId));
  return w ? w.id : null;
}

export function getCharacter(charId) {
  for (const w of WORLDS) {
    const c = w.characters.find((ch) => ch.id === charId);
    if (c) return c;
  }
  return null;
}

